<template>
    <div>
        <div class="video-preview">
            <video preload="metadata" :src="videoUrl + '#t=0.001'"></video>
            <button type="button" aria-label="Відтворити відео" @click="$emit('videoopen')" :title="title" class="video-preview-btn">
                <icon-type-video class="video-preview-icon"/>
            </button>
        </div>
        <div class="video-title">{{ title }}</div>
    </div>
</template>

<script>
import IconTypeVideo from '../../icons/IconTypeVideo';

export default {
    name: 'VideoPreview',
    components: { IconTypeVideo },
    props: ['videoUrl', 'title'],
}
</script>

<style scoped lang="scss">

@import "../../../../../sass/front/helpers";

.video-title {
    white-space: nowrap;
    max-width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    color: #252525;
    font-weight: 500;
    margin-top: 0.6rem;
}

.video-preview {
    position: relative;
    overflow: hidden;
    border-radius: 9px;
    width: 100%;
    display: block;
    height: 0;
    padding-bottom: 65%;
    pointer-events: auto;
    border: 1px solid #eee;

    @media (hover: hover) {
        &:hover {
            .video-preview-icon {
                transform: translate(-50%, -50%) scale(1.1);
            }
        }
    }

    &-btn,
    video {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 9px;
        display: block;
        object-fit: cover;
        z-index: 1;
    }

    &-btn {
        display: flex;
        align-items: flex-end;
        padding: 11px;
        z-index: 3;
        color: #fff;
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
        text-decoration: none;
        box-shadow: none;
        cursor: pointer;
        border: 0;
        background: linear-gradient(180deg, rgba(6, 6, 6, 0.00) 0%, rgba(0, 0, 0, 0.40) 100%);

        @include responsive-below($md) {
            font-size: 12px;
            padding: 6px 11px;
        }
    }

    &-icon {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%) scale(1);
        display: block;
        color: #fff;
        width: 17%;
        height: auto;
        z-index: 2;
        transition: transform 0.3s ease-in-out;
    }
}
</style>
